import createAccordion from "@/js/utils/accordion.js";

const blockContentAndAccordion = () => {
    createAccordion('.accordion');
};

export default blockContentAndAccordion;
